import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { SVGPureIcon } from '@/ui';
import wsStore from './store';
import appLogger from '@public/log/monitor';

function SuggestList(props) {
  const store = wsStore;
  const { className, items = [], onClick } = props;
  const { hotWords } = store.cloudConfig;
  useEffect(() => {
    store.getHotWord();
  }, []);
  
  if (!(hotWords && hotWords.length)) {
    return null;
  }
  return (
    <section
      className={['w-full mt-[16px] flex flex-col gap-[8px]', className]}
    >
      <ul className="mb-0 flex flex-col items-start gap-[8px]">
        {hotWords.map(({ title }, index) => (
          <li
            key={index}
            className={[
              'w-full flex justify-between items-center',
              'cursor-pointer',
              'rounded-[12px] border border-solid border-black border-opacity-10',
              'px-[16px] py-[10px]',
              'text-[14px] text-black leading-normal',
              'hover:bg-[#F6F7F9] hover:border-none hover:py-[11px]'
            ]}
            onClick={() => {
              appLogger.log({
                action : "click",
                arrt : "aibot_plugin_sidebar_guess_question",
                ext : title,
              });
              store.sendMessage({ input: title });
            }}
          >
            {title}
            <SVGPureIcon name="arrow_right" className="w-[16px] h-[16px]" />
          </li>
        ))}
      </ul>
    </section>
  );
}

export default observer(SuggestList);
